export class PropertySearch {
  availability: string = null;
  property_type: string;
  listing: string = null;
  for_sale: boolean = false;
  to_let: boolean = false;
  promo: boolean = false;
  sort: string = null;
  min_buy_price_eur: number = null;
  max_buy_price_eur: number = null;
  min_let_price_eur: number = null;
  max_let_price_eur: number = null;
  min_front_length_m: number = null;
  max_front_length_m: number = null;
  min_land_size_sqm: number = null;
  max_land_size_sqm: number = null;
  min_size_sqm: number = null;
  max_size_sqm: number = null;
  room_count: number = null;
  year_built: string;
  layout_id: number = null;
  confort_id: number = null;
  intermediate_floor: boolean;
  street_floor: boolean;
  last_floor: boolean;
  built_finished: boolean;
  land_type_id: number;
  land_class_id: number;
  layouts: string;
  floor: string = null;
  home_type: number | string = null;
  page: number;
  project_id: number = null;
  kitchen_type: string = null;

  zone_id: number = null;
  type_names: string[] = [];
  home_types: string[] = [];
  floor_ids: string[] = [];
  zone_ids: number[] = [];
  layout_ids: number[] = [];
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/property-search.model.ts